/** Имя куки */
const COOKIE_NAME = "goodok-cookie-accepted";

/**
 * Класс для управления cookie-баннером.
 *
 * - При инициализации проверяет наличие куки cookie-accepted
 * - Если куки нет — показывает баннер
 * - При клике на кнопку "ОК" — устанавливает куку и скрывает баннер
 */
class CookieBanner {
  constructor() {
    /** @type {HTMLElement|null} Элемент баннера */
    this.banner = document.getElementById("cookie-banner");
    /** @type {HTMLElement|null} Кнопка принятия */
    this.acceptButton = document.getElementById("cookie-banner-accept");
    /** @type {boolean} Флаг наличия куки */
    this.hasCookie = this._checkCookie();

    this._init();
  }

  /**
   * Инициализирует работу баннера.
   *
   * @private
   * @returns {void}
   */
  _init() {
    if (this.hasCookie || !this.banner || !this.acceptButton) return;

    this._showBanner();

    this.acceptButton.addEventListener("click", () => this._onAccept());
  }

  /**
   * Показывает баннер.
   *
   * @private
   * @returns {void}
   */
  _showBanner() {
    if (!this.banner) return;

    this.banner.classList.remove("cookie-banner--hidden");
  }

  /**
   * Скрывает баннер.
   *
   * @private
   * @returns {void}
   */
  _hideBanner() {
    if (!this.banner) return;

    this.banner.addEventListener("transitionend", () => this._onTransitionEnd());

    this.banner.classList.add("cookie-banner--hidden");
  }

  /**
   * Обработчик клика по кнопке "ОК".
   * Устанавливает куку и скрывает баннер.
   *
   * @private
   * @returns {void}
   */
  _onAccept() {
    this._setCookie();
    this._hideBanner();
  }

  /**
   * Обработчик окончания анимации закрытия баннера
   *
   * @private
   * @returns {void}
   */
  _onTransitionEnd() {
    this.banner.removeEventListener("transitionend", this._onTransitionEnd);

    this._destroy();
  }

  /**
   * Проверяет наличие куки с указанным именем.
   *
   * @private
   * @returns {boolean} true — кука есть, false — куки нет
   */
  _checkCookie() {
    return document.cookie.match(`${COOKIE_NAME}=true`);
  }

  /**
   * Устанавливает куку с указанным именем.
   *
   * @private
   * @returns {void}
   */
  _setCookie() {
    const expires = new Date();
    expires.setDate(expires.getDate() + 365);

    document.cookie = `${COOKIE_NAME}=true; expires=${expires.toUTCString()}; path=/; SameSite=Lax`;
  }

  /**
   * Уничтожает баннер и чистит все ссылки.
   *
   * @private
   * @returns {void}
   */
  _destroy() {
    if (!this.banner) return;

    /** Удаляем из DOM */
    this.banner.parentNode?.removeChild(this.banner);

    /** Обнуляем ссылки для сборщика мусора */
    this.banner = null;
    this.acceptButton = null;
  }
}

export default CookieBanner;
